/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

import {assert} from 'chai';

import {Visitor} from '../../typescript/typescript-document';
import {TypeScriptImportScanner} from '../../typescript/typescript-import-scanner';
import {TypeScriptPreparser} from '../../typescript/typescript-preparser';

suite('TypeScriptImportScanner', () => {

  suite('scan()', () => {

    let scanner: TypeScriptImportScanner;

    setup(() => {
      scanner = new TypeScriptImportScanner();
    });

    test('finds no imports', async() => {
      const source = ``;
      const parser = new TypeScriptPreparser();
      const document = parser.parse(source, 'test.ts');
      const visit = async(visitor: Visitor) => document.visit([visitor]);
      const features = await scanner.scan(document, visit);
      assert.equal(features.length, 0);
    });

    test('finds multiple import', async() => {
      const source = `
        import * as x from './x.ts';
        import * as y from '/y.ts';
        import * as z from '../z.ts';
      `;
      const parser = new TypeScriptPreparser();
      const document = parser.parse(source, 'test.ts');
      const visit = async(visitor: Visitor) => document.visit([visitor]);
      const features = await scanner.scan(document, visit);
      assert.deepEqual(features.map((f) => [f.type, f.url]), [
        ['js-import', 'x.ts'],
        ['js-import', '/y.ts'],
        ['js-import', '../z.ts'],
      ]);
    });

  });

});
